"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
interface ParkingsSectionProps {
  value: number | null;
  onChange: (value: number | null) => void;
}
const PARKING_OPTIONS = [{
  value: 1,
  label: "1+"
}, {
  value: 2,
  label: "2+"
}, {
  value: 3,
  label: "3+"
}, {
  value: 4,
  label: "4+"
}, {
  value: 5,
  label: "5+"
}, {
  value: 6,
  label: "6+"
}, {
  value: 7,
  label: "7+"
}, {
  value: 8,
  label: "8+"
}];
export function ParkingsSection(t0) {
  const $ = _c(5);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = PARKING_OPTIONS.map((option, index) => {
      const isSelected = option.value === value;
      return <button type="button" key={option.value} onClick={() => onChange(isSelected ? null : option.value)} className={cn("py-3 text-sm font-medium transition-colors", "flex-shrink-0 min-w-[60px] md:flex-1 md:min-w-0", index === 0 && "rounded-l-xl", index === PARKING_OPTIONS.length - 1 && "rounded-r-xl", index > 0 && "border-l border-gray-300", "px-4 py-3 text-body shadow-sm hover:bg-neutral-300 cursor-pointer", isSelected ? "bg-primary-400 text-primary-600" : "bg-white text-gray-600 hover:bg-gray-50")}>{option.label}</button>;
    });
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex border border-gray-300 rounded-xl overflow-hidden md:overflow-x-visible overflow-x-auto">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}